import React from 'react';
import { Users, Heart, Clock } from 'lucide-react';

const AboutSection = () => {
  return (
    <section
      id="about"
      className="py-20 md:py-32 bg-white"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://customer-assets.emergentagent.com/job_github-sync-86/artifacts/yz5su02q_ChatGPT%20Image%20May%2020%2C%202026%2C%2003_21_39%20PM.png"
                alt="Front exterior of Abney Low Nursing Home in Hoylake, Wirral"
                className="w-full h-[400px] lg:h-[500px] object-cover"
              />
            </div>
            {/* Floating Badge */}
            <div className="absolute -bottom-6 -right-6 bg-[#1e3a5f] text-white p-6 rounded-2xl shadow-xl hidden lg:block">
              <div className="text-3xl font-bold text-[#c9a227]">40</div>
              <div className="text-sm">Resident Capacity</div>
            </div>
          </div>

          {/* Content */}
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#c9a227]/10 rounded-full text-[#c9a227] text-sm font-medium mb-6">
              About The Home
            </div>
            
            <h2
              className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1e3a5f] mb-6 leading-tight"
             
            >
              A Caring Home in the Heart of Hoylake
            </h2>

            <p className="text-slate-600 text-lg mb-6 leading-relaxed">
              Abney Low Nursing Home is a well-established care home located in Hoylake, Wirral, offering high-quality nursing, residential and dementia care in a comfortable and supportive setting.
            </p>

            <p className="text-slate-600 mb-8 leading-relaxed">
              Our home accommodates up to 40 residents and is designed to provide a safe, accessible and homely environment. With a dedicated team of experienced nurses and carers available 24 hours a day, we ensure every resident receives the care, dignity and respect they deserve.
            </p>

            <p className="text-slate-600 mb-10 leading-relaxed">
              Residents are encouraged to personalise their rooms and maintain their independence, while enjoying the reassurance of professional support whenever it is needed.
            </p>

            {/* Features */}
            <div className="grid sm:grid-cols-3 gap-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-[#1e3a5f]/10 flex items-center justify-center flex-shrink-0">
                  <Users className="w-6 h-6 text-[#1e3a5f]" />
                </div>
                <div>
                  <h4 className="font-semibold text-[#1e3a5f]">Expert Team</h4>
                  <p className="text-sm text-slate-500">24/7 professional care</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-[#c9a227]/10 flex items-center justify-center flex-shrink-0">
                  <Heart className="w-6 h-6 text-[#c9a227]" />
                </div>
                <div>
                  <h4 className="font-semibold text-[#1e3a5f]">Compassion</h4>
                  <p className="text-sm text-slate-500">Dignity & respect</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-[#1e3a5f]/10 flex items-center justify-center flex-shrink-0">
                  <Clock className="w-6 h-6 text-[#1e3a5f]" />
                </div>
                <div>
                  <h4 className="font-semibold text-[#1e3a5f]">Always Here</h4>
                  <p className="text-sm text-slate-500">Round-the-clock support</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
